import * as React from "react"
import { ORION_IMG_URL } from "../../utils/AppConstants";

export interface AppLoaderProps {
    text?: string;
    className?: string;
}

class AppLoader extends React.Component<AppLoaderProps> {
    render() {
        return (
            <div className={this.props.className ? `app-loader-cont ${this.props.className}` : "app-loader-cont"}>
                <img src={"/images/loader/section-loader.png"} />
                {
                    this.props.text !== undefined &&
                    <div>{this.props.text}</div>
                }
            </div >
        );
    }
}

export default AppLoader;